import { Box, FormControl, Stack, Typography } from '@mui/material';

import {
  ErrorOutlineIconStyled,
  FormHelperTextWrapperStyled,
  FormLabelStyled,
} from './FormFieldStyled';
import { Spacer } from 'theSource/components/Spacer';

export interface FormFieldProps {
  disabled?: boolean;
  error?: boolean;
  fullWidth: boolean;
  helperText?: string;
  inputId: string;
  labelId?: string;
  label?: string;
  required?: boolean;
  testId?: string;
  children: JSX.Element;
}

export const FormField = ({
  children,
  error,
  helperText,
  inputId,
  labelId,
  label,
  testId,
  fullWidth,
  disabled,
  required,
}: FormFieldProps) => {
  return (
    <FormControl
      data-testid={testId}
      disabled={disabled}
      error={error}
      fullWidth={fullWidth}
      required={required}
    >
      <Stack spacing={1}>
        {label && (
          <FormLabelStyled htmlFor={inputId} id={labelId}>
            {label} {required && <span className="red">*</span>}
          </FormLabelStyled>
        )}
        {children}
        {helperText && (
          <FormHelperTextWrapperStyled
            data-testid="helper-text"
            component="div"
          >
            {error && (
              <Box>
                <ErrorOutlineIconStyled
                  data-testid="error-icon"
                  aria-hidden="true"
                />
              </Box>
            )}
            <Spacer width={1} />
            <Typography variant="caption" role="alert" aria-live="assertive">
              {helperText}
            </Typography>
          </FormHelperTextWrapperStyled>
        )}
      </Stack>
    </FormControl>
  );
};
